import React from 'react';
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import IndexBenchMark from "../echart/IndusBenchMark"
import ObservedInd from 'pages/Dashboard/ObservedInd';
import IndustryOverview from 'pages/Dashboard/IndustryOverview';
const IndexBenchMarking = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <h3>Cables R Us</h3>
                    <Row>
                        <Col lg="8">
                            <IndexBenchMark/>
                        </Col>
                        <Col lg="4">
                        <ObservedInd/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <IndustryOverview/>
                        </Col>
                    </Row>

                </div>
            </div>
        </React.Fragment>
    );
};

export default IndexBenchMarking;
